import Controller from './application_controller'

export default class extends Controller {
  connect() {
    // Dialog elements should not propage clicks back to the main application.
    // This is to prevent in particular click:outside events from being triggered
    // from dialog clicks.
    this.addEventListener('click', event => event.stopPropagation())
  }

  close() {
    this.element.close()
  }
}